module.exports = __webpack_public_path__ + "static/media/gameStart_1.be3268c3.mp3";